<template>
  <div class="apply" ref="apply">
    <Form class="form" label-position="top">
      <FormItem label="工程名称">
        <Input v-model="searchQuery.Gcmc" />
      </FormItem>
      <FormItem label="工程地址">
        <Input v-model="searchQuery.Jzdz" />
      </FormItem>
      <FormItem label="建设单位">
        <Input v-model="searchQuery.Jsdw" />
      </FormItem>
      <Button
        long
        type="primary"
        @click="handleSubmit"
      >查询</Button>
    </Form>
    <Card v-for="d in data" :key="d.SID" shadow>
      <template v-slot:title>
        <Checkbox
          :value="selection.some(s => s.SID === d.SID)"
          class="checkbox"
          :disabled="selection.length >= maxSelect && !selection.some(s => s.SID === d.SID)"
          @on-change="boolean => { handleCheckboxChange(boolean, d) }"
        >{{ d.ENG_NAME }}</Checkbox>
      </template>
      <div class="item" v-for="c in columns" :key="c.key">
        <label>{{ `${c.label}：` }}</label>
        <span>{{ d[c.key] }}</span>
      </div>
      <div class="btn">
        <Button
          type="info"
          :disabled="!d.LNG"
          size="small"
          @click="openGIS(d)"
        >地图</Button>
      </div>
    </Card>
    <p class="tips" v-if="loadingTips">{{ loadingTips }}</p>
  </div>
</template>

<script>
import { GetEngineers } from '@api'
export default {
  name: 'search-mobile-apply',
  props: {
    selection: {
      type: Array,
      default: () => []
    },
    maxSelect: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      searchQuery: {
        Jsdw: '',
        Jzdz: '',
        Gcmc: ''
      },
      single: false,
      data: [],
      columns: [],
      current: 1,
      pageSize: 10,
      loadingTips: '',
      loading: false,
      noMore: false
    }
  },
  computed: {
    offsetHeight () {
      return this.$store.state.init.offsetHeight
    }
  },
  mounted () {
    this.buildColumns()

    // 监测滚动条，滚到底部加载下一页
    this.$refs['apply'].addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleSubmit () {
      this.data = []
      this.current = 1
      this.noMore = false
      this.loadingTips = ''
      if (Object.values(this.searchQuery).every(e => e === '')) {
        this.$Message.warning('必须录入一个查询条件')
        return
      }
      this.getPage()
    },
    buildColumns () {
      const columns = [
       {
          key: 'ENG_LOCATION',
          label: '地址'
        }, {
          key: 'DEVELOPMENTS_ORG_NAME',
          label: '建设单位'
        }, {
          key: 'CONSTRUCT_ORG_NAME',
          label: '施工单位'
        }
      ]
      this.$set(this, 'columns', columns)
    },
    async getPage () {
      try {
        const query = {
          PageIndex: this.current,
          PageSize: this.pageSize,
          ...this.searchQuery
        }
        const { data: { list, total } } = await GetEngineers(query)
        if (list.length === 0) {
          this.loadingTips = '没有更多数据了'
          this.noMore = true
        }
        this.data.push(...list)
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },
    handleCheckboxChange (boolean, row) {
      if (boolean) {
        this.$emit('on-select', row)
      } else {
        this.$emit('on-select-cancel', row)
      }
    },
    handelReachBottom () {
      this.loading = true
      this.loadingTips = '加载更多中...'
      this.current++
      this.getPage()
    },
    openGIS ({ SID }) {
      const { GISUrl } = window.config
      window.open(`${ GISUrl }?id=${ SID }`, '_blank')
    },
    handleScroll (even) {
      if (this.noMore || this.loading) return
      const { scrollTop, scrollHeight, offsetHeight } = even.target
      if (scrollTop + offsetHeight + 200 > scrollHeight) {
        this.handelReachBottom()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.apply {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.form {
  margin-bottom: 8px;
  background: #fff;
  padding: 16px;
  .ivu-btn {
    margin-top: 6px;
  }
}
.ivu-card {
  margin: 0 8px 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
  .checkbox {
    color: $default;
  }
  .item {
    display: flex;
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    span {
      flex: 1;
      text-align: right;
    }
  }
  .btn {
    text-align: right;
  }
}
.tips {
  text-align: center;
  margin-bottom: 8px;
}
</style>